// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		//suggestionMode: 'test',
		suggestionStyle: 'style2',
		suggestionStyle2MainContainerSelector: '#shopify-section-header',
		suggestionMobileStyle: 'style2',
      	suggestionBlocks: [
			{ type: 'products', label: 'Products', status: 'active', number: 6 },
			{ type: 'suggestions', label: 'Suggestions', status: 'active', number: 3 },
			{ type: 'collections', label: 'Collections', status: 'active', number: 2 },
			{ type: 'pages', label: 'Pages', status: 'active', number: 2 },
		],
        suggesionMaxItems: 6,
	}
};

//Set theme search mode to product only
window.theme.searchMode = 'product';

(function() {
    BoostPFS.inject(this);

    // Customize style of Suggestion box
    SearchInput.prototype.customizeInstantSearch = function() {
        var suggestionElement = this.$uiMenuElement;
        var searchElement = this.$element;
        var searchBoxId = this.id;
    };

    SearchInput.prototype.beforeBindEvents = function(id) {
        var id = this.id;
        if (id == Class.searchBox + '-0') {
            this.$element = removeThemeSearchEvent();
            this.instantSearchResult.$searchInputElement = this.$element;
        }
        recallThemeOnPageShowEvent();

        if (Utils.InstantSearch.isFullWidthMobile()) {
            jQ(id).removeAttr('autofocus');
            if (jQ(id).is(':focus')) {
                jQ(id).blur();
            }
        }
    };

    SearchInput.prototype.afterBindEvents = function() {
        // Fix cannot redirect to search page when pressing enter
        jQ('.boost-pfs-search-box').on('keypress', function(event) {
            if (event.keyCode == 13) {
                jQ(this).parents('form').submit();
            }
        })
    }

    function removeThemeSearchEvent() {
        // Remove all events
        if (jQ('[name="q"]').length > 0) {
            var cloneSearchBar = jQ('[name="q"]').first().clone();
            jQ(cloneSearchBar).removeClass('Form__Input').addClass('Search__Input Heading');
            jQ('[name="q"]').first().empty().append(cloneSearchBar);
            if (jQ('#Search').length > 0) {
                if (jQ('#Search').hasClass('Modal--fullScreen')) {
                    jQ('#Search').attr("style", "height: 0px !important");
                }
                jQ('#Search .Search__Results').attr("style", "display: none !important");
            }

            // Rebuild click search icon event
            if (jQ('[data-action="toggle-search"]').length > 0) {
                jQ('[data-action="toggle-search"]').on('click', function() {
                    setTimeout(function() {
                        jQ('[name="q"]').first().focus();
                    }, 500);
                })
            }
        }
        // disable page transition
        if (window.theme && window.theme.showPageTransition) {
            window.theme.showPageTransition = false;
        }
        return jQ('[name="q"]').first();
    }

    function recallThemeOnPageShowEvent() {
        // disable page transition
        var pageTransition = document.querySelector('.PageTransition');
        if (pageTransition) {
            pageTransition.style.visibility = 'visible';
            pageTransition.style.opacity = '0';
        }
        // refresh cart
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true
        }));
    }

    /* start-boost-custom */
    SearchInput.prototype._onTypeSearchBoxEvent = function(event) {
        Globals.currentTerm = event.target.value;
        if (event.target.value == "") {
            jQ('body').removeClass("search-opened");
            jQ('.boost-pfs-search-suggestion').empty();
            setTimeout(function() {
                jQ('.clear-button').click();
            }, 200);
        }
    };

    InstantSearchResult.prototype._renderSuggestion = function() {
        if (this.$instantSearchResult) {
            this.$instantSearchResult.attr('data-search-box', this.id);
        }
        if (this.data) {
            var suggesionChildElements = [];
            var isAllEmpty = Utils.getValueInObjectArray(InstantSearchEnum.ResultType.ALL_EMPTY, this.data);
            if (isAllEmpty) {
                // If have search redirect and no result, hide the search suggestion
                if (this.blockEmpty.$element) {
                    suggesionChildElements.push(this.blockEmpty.$element);
                    this.blocks.forEach((block) => {
                        suggesionChildElements.push(block.$element);
                    });
                } else {
                    this.$wrapper.hide();
                }
            } else {
                this.blocks.forEach((block) => {
                    suggesionChildElements.push(block.$element);
                });
                // Append view all block
                suggesionChildElements.push(this.blockViewAll.$element);
            }
            // Append to DOM
            if (Utils.isMobile()) {
                var newChildEl = [];
                var newChildEl1 = [];
                var newChildEl2 = [];
                for (var i = 0; i < suggesionChildElements.length; i++) {
                    //console.log(suggesionChildElements[i]);
                    if (typeof(suggesionChildElements[i][0]) !== "undefined" && typeof(suggesionChildElements[i][0].dataset) !== "undefined" && suggesionChildElements[i][0].dataset.group == "products" || typeof(suggesionChildElements[i][0]) !== "undefined" && typeof(suggesionChildElements[i][0].className) !== "undefined" && suggesionChildElements[i][0].className == "boost-pfs-search-suggestion-header-view-all boost-pfs-search-suggestion-header") {
                        newChildEl1.push(suggesionChildElements[i]);
                    } else {
                        newChildEl2.push(suggesionChildElements[i]);
                    }
                }
                newChildEl = newChildEl1.concat(newChildEl2);
                var selector = this.$instantSearchResult;
              	newChildEl.forEach(function(element) {
                    if (element.length > 0) selector.append(element)
                });
//                 this.$instantSearchResult.append(newChildEl);
                var allProducts = this.blockViewAll.$element.text().replace(/View all/g, '').replace(/product\(s\)/g, '').replace(/product/g, '').replace(/ s/g, '').trim();
                var headerProductText = jQ('.boost-pfs-search-suggestion-header-products').text();
                jQ('.boost-pfs-search-suggestion-header-products').text(headerProductText + ' (' + allProducts + ')');
            } else {
                var selector = this.$instantSearchResult;
                suggesionChildElements.forEach(function(element) {
                    console.log(element.length);
                    if (element.length > 0) selector.append(element)
                });
                //         this.$instantSearchResult.append(suggesionChildElements);
            }
            jQ(".boost-pfs-search-suggestion-mobile *").on("click", function() {
                jQ("#boost-pfs-search-box-mobile").attr("readonly", true);
            });
            jQ("#boost-pfs-search-box-mobile").on("click", function() {
                jQ(this).removeAttr("readonly");
                jQ(this).focus();
            });
        }
    };

    InstantSearchResult.prototype.render = function() {
        if (this.isFirstLoad) {
            // Render initial suggestion container and append it to the dom
            var suggestionHtml = this.compileTemplate();
            this.appendToSelector = '#Search';
            this._applyFilterAutocompleteAppendElement();

            jQ(this.appendToSelector).append(suggestionHtml);
            this.$wrapper = jQ(this.selector.wrapper);
            this.$popoverElement = jQ(this.selector.popover);
            this.isFirstLoad = false;
        } else {
            // Show the suggestion popover
            this.$instantSearchResult.siblings().show();
            // Render suggestion blocks and items
            if (this.isLoading) {
                this._renderSuggestionLoading();
                this._renderWrapper();
            } else {
                this._renderWrapper();
                this._renderSuggestion();
            }
            //this._renderSuggestionStyle();
        }

        jQ('.Search__Input').keyup(function() {
            var input = jQ(this).attr('id');
            if (jQ('.Search__Input').val() != "") {
                jQ('.clear-button').removeClass('hide-clear');
            }
        });

        jQ('.clear-button').on('click', function() {
            jQ(".boost-pfs-search-box").val("");
            jQ('.clear-button').addClass('hide-clear');
        })

        jQ(".Search__Input").on("input", function() {
            jQ(".boost-pfs-search-suggestion-wrapper").css('display', 'block');
        })

    }

    InstantSearchMobile.prototype.openSuggestionMobile = function() {
        // Before opening suggestion
        this.beforeOpenSuggestionMobile();
        // Add a specific class to prevent body from scrolling
        if (!jQ('body').hasClass(Class.searchSuggestionMobileOpen)) {
            jQ('body').addClass(Class.searchSuggestionMobileOpen);
        }
        // Dsisplay the Search box on Top
        this.showSearchBoxMobile();
        this.$searchInput.autocomplete('search');
        this.searchBox.instantSearchResult.$wrapper.show();
        // Scroll to the top when clicking to the search box
        // jQ('html,body').scrollTop();
        // After opening suggestion
        this.afterOpenSuggestionMobile();
    }
    /* end-boost-custom */

    var onCloseAutocomplete = SearchInput.prototype.onCloseAutocomplete;

    SearchInput.prototype.onCloseAutocomplete = function() {
        if (!Utils.isMobile()) {
            onCloseAutocomplete.call(this);
            return;
        }

        this.instantSearchResult.$instantSearchResult.show();
        var container = this.instantSearchResult.$wrapper;
        var self = this;

        jQ(document).on('click', function(e) {
            if (!container.is(e.target) && container.has(e.target).length === 0 &&
                !self.$element.is(e.target) && self.$element.has(e.target).length === 0) {
                self.instantSearchResult.$instantSearchResult.siblings().hide();
                self.instantSearchResult.$wrapper.removeClass(Class.searchSuggestionOpen);
            }

        });
    }

    jQ(document).ready(function() {
        if (jQ('.is-visible')) {
            jQ('.PageOverlay').on('click', function() {
                jQ('.Search__Close').click();
            })
        }
//         jQ('[data-action="toggle-search"]').on('click tap', function() {
//             if (Utils.isMobile()) {
//                 // create invisible dummy input to receive the focus first
//                 const fakeInput = document.createElement('input')
//                 fakeInput.setAttribute('type', 'text')
//                 fakeInput.style.position = 'absolute'
//                 fakeInput.style.opacity = 0
//                 fakeInput.style.height = 0
//                 fakeInput.style.fontSize = '16px' // disable auto zoom
//                 document.body.prepend(fakeInput)
//                 fakeInput.focus()
//                 var element = document.getElementById('boost-pfs-search-box-0');
//                 if (element !== null) {
//                     window.setTimeout(() => {
//                         element.focus();
//                         fakeInput.remove();
//                     }, 1000);
//               	}
//             } else {
//                 var element = document.getElementById('boost-pfs-search-box-0');
//                 window.setTimeout(() => element.focus(), 1000);
//             }
//         });
    })
})();